/* Publish by EComposer at 2024-06-05 08:07:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3f7l1fbacx7"]=  window.__ectimmers["ecom-3f7l1fbacx7"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",t.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-3f7l1fbacx7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3f7l1fbacx7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ccyg1ljf0ps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccyg1ljf0ps', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-anoam7lcxi7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-anoam7lcxi7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7fso07egajk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7fso07egajk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y80lptvkaug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y80lptvkaug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8lygkuejpjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8lygkuejpjc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hes04i70z97"]=  window.__ectimmers["ecom-hes04i70z97"] || {};
const e=this.$el;if(!e||!this.isLive)return;const t=e.querySelector(".element__featured--wrapper-list");if(t){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;t.scrollLeft=i.left-a},s=function(){t.removeEventListener("mousemove",n),t.removeEventListener("mouseup",s),t.style.cursor="default",t.style.removeProperty("user-select")},o=function(r){t.style.cursor="grabbing",t.style.userSelect="none",i={left:t.scrollLeft,top:t.scrollTop,x:r.clientX,y:r.clientY},t.addEventListener("mousemove",n),t.addEventListener("mouseup",s)};t.addEventListener("mousedown",o),t.addEventListener("mouseleave",s)}

                    });
                    
                        document.querySelectorAll('.ecom-hes04i70z97').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hes04i70z97', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-maw0t50sm2f"]=  window.__ectimmers["ecom-maw0t50sm2f"] || {};
var e;if(!this.$el)return;const t=this.$el;if(this.settings.style==="slider"){let i=t.querySelector(".ecom-swiper-container"),s=i&&i.dataset.optionSwiper;if(!s)return;let l="bullets";this.settings.slider_pagination_style==="progress"&&(l="progressbar"),s=JSON.parse(s),s.pagination={el:t.querySelector(".ecom-swiper-pagination"),type:l,clickable:!0},s.navigation={nextEl:t.querySelector(".ecom-swiper-button-next"),prevEl:t.querySelector(".ecom-swiper-button-prev")},s.autoHeight=!1,s.spaceBetween=(e=this.settings.slider_spacing)!=null?e:25,window.EComSwiper&&new window.EComSwiper(i,s)}

                    });
                    
                        document.querySelectorAll('.ecom-maw0t50sm2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-maw0t50sm2f', settings: {"style":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gstgv617t3t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gstgv617t3t', settings: {"style":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}